import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { PortalRoutes } from '@app/app-routing.module';
import { PortalReferralProgramNode } from '@app/services/api/api.types';
import { REFERRAL_ENVELOPE_IMAGE } from '@app/utils/referral-assets';

@Component({
  selector: 'referral-home-banner',
  templateUrl: './referral-home-banner.component.html',
  styleUrls: ['./referral-home-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferralHomeBannerComponent {
  PortalRoutes = PortalRoutes;

  @Input({ required: true }) program!: PortalReferralProgramNode;

  REFERRAL_ENVELOPE_IMAGE = REFERRAL_ENVELOPE_IMAGE;
}
